  <template>
  <sw-modal :open="showModal" @close="$emit('close')">
    <sw-panel class="modal-template-save center-y">
      <span slot="header" class="flex center base-modal-title">Enregistrement du template</span>
      <span class="base-modal-content">{{label}}</span>
      <div class="loader-wrapper" v-if="this.editor && this.editor._convertAllImg64().length > 0">
        <span class="total-percent-label">{{getTotalPercent}}</span>
        <loading-progress
          :progress="totalPercent"
          :indeterminate="false"
          size="80"
          rotate
          fillDuration="2"
          rotationDuration="1"
        />
      </div>
    </sw-panel>
  </sw-modal>
</template>
<script>
import { EventBus, NOTIFICATION_INFO, TEMPLATE_SAVE } from '@/model/EventBus';
import HttpConnector from '@/model/http/HttpConnector';
import { empty, not } from 'junctions-fp';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'TemplateSaveModal',
  components: {},
  beforeCreate() {
    //this.dictionnary = await this.getLanguages
  },
  async created() {
    EventBus.$on(TEMPLATE_SAVE, this.onSaveTemplate)
    this.dictionnary = await this.getLanguages
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {
    EventBus.$off(TEMPLATE_SAVE, this.onSaveTemplate)
  },
  data() {
    return {
      dictionnary: null,
      showModal: false,
      uploadFilesLength: 0,
      currentUploadedFiles: 0,
      totalPercent: 0,
      label: '',
      tmp: 0,
      sa: -1.5
    }
  },
  props: {
    editor: null
  },
  computed: {
    ...mapGetters(['getCurrentFormat', 'getLanguages', 'currentTemplate']),
    getTotalPercent() {
      return `${Math.floor(this.totalPercent * 100)}%`
    },
    getImagesUploaded() {
      return `${this.currentUploadedFiles} / ${this.uploadFilesLength}`
    }
  },
  methods: {
    ...mapActions(['saveTemplate', 'updateTemplate']),
    async onSaveTemplate(name) {
      try {
        this.showModal = true
        const dt = await this.exportTemplateHandler()
        this.label = this.dictionnary.templateMenu.templateUpload
        const template = { ...this.getCurrentFormat, template: dt.data, preview : dt.preview }
        if (name) {
          template.name = name
          await this.saveTemplate(template)
        } else {
          const upt = { ...this.currentTemplate, ...this.getCurrentFormat, template: dt.data, preview: dt.preview }
          await this.updateTemplate(upt)
        }
        EventBus.$emit(NOTIFICATION_INFO, { type: 'infos', code: 'templateSaved', class: 'info' })
        this.$emit('changeMenu', 'DefaultMenu')
        this.showModal = false
      } catch (e) {
        EventBus.$emit(NOTIFICATION_INFO, { type: 'infos', code: e.message, class: 'danger' })
        this.showModal = false
      }
    },

    async exportTemplateHandler() {
      const exportTemplate = this.editor.export()
      const convertedImgs64 = [...this.editor._convertAllImg64(), this.editor.templateThumb()]
      let preview = ''
      if (not(empty(convertedImgs64))) {
        this.uploadFilesLength = convertedImgs64.length
        this.label = this.dictionnary.templateMenu.imageUpload
        const result = await HttpConnector.getInstance().uploadAllTemplateImages(convertedImgs64, this.progressUpload)
        if (not(empty(result))) {
          result.forEach(value => {
            const image = exportTemplate.objects.find(item => item.uid === value.uid)
            if(image){
              image.src = value.url
            }else{
              preview = value.url
            }
          })
        }
      }
      return {data:exportTemplate, preview}
    },
    progressUpload(evt) {
      this.totalPercent = evt.loaded / evt.total
      const percent = (evt.loaded / evt.total) * 100
      if (percent === 100) {
        this.currentUploadedFiles++
      }
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/modal/TemplateSaveModal.vue